import { render, staticRenderFns } from "./PublicNavMenuItems.vue?vue&type=template&id=bf1f406a&"
import script from "./PublicNavMenuItems.vue?vue&type=script&lang=js&"
export * from "./PublicNavMenuItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports